import React, { useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import { useRefCode } from 'hooks';
import type { SelectProps } from 'antd';

interface FormItemProps {
  form: any
}

const LectureTypeFormItem = ({form}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [codeList, setCodeList] = useState<SelectProps['options']>([]);
  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: lectureTypetList } = useRefCode({field:'lecture_type1', status_type: 'AV'});  

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
  * effects
  * ====================================================== */  
  useEffect(() => {
    const options = lectureTypetList?.map((item) => {return {value: item.name, label: item.value}}) || [];
    setCodeList(options);
  }, [lectureTypetList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="lecture_type1" style={{ width:'180px'}}>
        <Select 
          placeholder="강의 구분 선택" 
          options={codeList} />                
      </Form.Item> 
    </>
  );
};

export default LectureTypeFormItem;
